import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, tap } from 'rxjs/operators';
import { DistributorModel } from "../../models/distributor/distributor.model";
import { DistributorContactModel } from "src/app/models/distributor/distributorContact.model";

@Injectable({
    providedIn: 'root'
})
export class DistributorsDataService {

    private DISTRIBUTORSDATA_URL = 'api/distributorsData/GetActiveDistributors'
    private DISTRIBUTOR_URL = 'api/distributorsData/GetDistributor/'
    private DISTRIBUTOR_CONTACTS_URL = 'api/distributorsData/GetDistributorContacts/'
    private DISTRIBUTOR_EMERGENCY_CONTACTS_URL = 'api/distributorsData/GetEmergencyContacts/'
    private DISTRIBUTOR_SELECTED_EMERGENCY_CONTACTS_URL = 'api/distributorsData/GetSelectedEmergencyContacts/'
    private DISTRIBUTOR_DELETE_LOGO_URL = 'api/distributorsData/DeleteLogo'
    private DISTRIBUTOR_SAVE_URL = 'api/distributorsData/SaveDistributor'
    private DISTRIBUTOR_SAVE_PREF_URL = 'api/distributorsData/SaveDistributorPreferences'

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    get url(): string {

        return this.DISTRIBUTORSDATA_URL;
    }

    get getDistributorsData$(): Observable<DistributorModel[]> {
        return this._httpClient.get<DistributorModel[]>(this.DISTRIBUTORSDATA_URL);
    }


    getDistributor$(id: number): Observable<DistributorModel> {
        let tank = this._httpClient.get<DistributorModel>(`${this.DISTRIBUTOR_URL}${id}`);
        return tank;
    }

    getDistributorContacts$(id: number): Observable<DistributorContactModel[]> {
        return this._httpClient.get<DistributorContactModel[]>(`${this.DISTRIBUTOR_CONTACTS_URL}${id}`);
    }

    getEmergencyContacts$(id: number): Observable<DistributorContactModel[]> {
        return this._httpClient.get<DistributorContactModel[]>(`${this.DISTRIBUTOR_EMERGENCY_CONTACTS_URL}${id}`);
    }

    getSelectedEmergencyContacts$(id: number): Observable<DistributorContactModel[]> {
        return this._httpClient.get<DistributorContactModel[]>(`${this.DISTRIBUTOR_SELECTED_EMERGENCY_CONTACTS_URL}${id}`);  //TODO: need different model here??
    }

    /* saveDistributor$(distributorModel: DistributorModel): Observable<DistributorModel | null> {
        return this._httpClient.post<DistributorModel>(this.DISTRIBUTOR_SAVE_URL, { DistributorResponseModel: distributorModel }).pipe(
            tap(response => {

            }),
            catchError(error => {
                return of(error.error || 'Unknown error');
            }),
        );
    } */

    deleteLogo(distributorId: number): Observable<void> {
        return this._httpClient.delete<void>(`${this.DISTRIBUTOR_DELETE_LOGO_URL}/${distributorId}/logo`);
    }

    saveDistributor$(formData: FormData): Observable<any> {
        return this._httpClient.post<any>(
            this.DISTRIBUTOR_SAVE_URL,
            formData
        ).pipe(
            tap(response => { }),
            catchError(error => {
                return of(error.error || 'Unknown error');
            }),
        );
    }



    saveDistributorPreferences$(distributorModel: DistributorModel, emergencyContacts: Array<number>): Observable<DistributorModel | null> {
        return this._httpClient.post<DistributorModel>(this.DISTRIBUTOR_SAVE_PREF_URL, { DistributorResponseModel: distributorModel, EmergencyContacts: emergencyContacts }).pipe(
            tap(response => {

            }),
            catchError(error => {
                console.log(error);
                return of(null);
            }),
        );
    }

}
